"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.downloadConsumptionDocumentService = exports.fetchConsumptionsByMonthOrWeekServiceOld = exports.fetchConsumptionsServiceOld = exports.fetchConsumptionsByMonthOrWeekService = exports.fetchConsumptionsService = void 0;
var axiosInstance_1 = __importDefault(require("../helper/axiosInstance"));
var Consumption_1 = __importDefault(require("../models/Consumption"));
var index_1 = require("../index");
var common_1 = require("./common");
function fetchConsumptionsService(sectionSubscriptionIds, token, config) {
    var _a, _b, _c, _d;
    return __awaiter(this, void 0, void 0, function () {
        var configuration, route, response;
        return __generator(this, function (_e) {
            switch (_e.label) {
                case 0:
                    if (!index_1.urlsConfig.values)
                        throw Error('No urls config found');
                    if (config) {
                        return [2 /*return*/, fetchConsumptionsByMonthOrWeekService(sectionSubscriptionIds, config.mode, config.day, config.month, config.year, token)];
                    }
                    configuration = { headers: { Authorization: "Bearer ".concat(token) } };
                    route = "/section_subscriptions/consumptions";
                    return [4 /*yield*/, axiosInstance_1.default.post("".concat(index_1.urlsConfig.values.DELIVERYPOINT_BASE_URL).concat(route), sectionSubscriptionIds, configuration)];
                case 1:
                    response = _e.sent();
                    (0, common_1.LogRequestResponse)(response);
                    return [2 /*return*/, {
                            consumptions: (_a = response.data) === null || _a === void 0 ? void 0 : _a.consumptions.map(function (d) { return new Consumption_1.default(d); }),
                            isRemoteReading: (_b = response.data) === null || _b === void 0 ? void 0 : _b.isRemoteReading,
                            isEstimateConsumption: (_c = response.data) === null || _c === void 0 ? void 0 : _c.isEstimateConsumption,
                            isYearlyViewOnly: (_d = response.data) === null || _d === void 0 ? void 0 : _d.isYearlyViewOnly
                        }];
            }
        });
    });
}
exports.fetchConsumptionsService = fetchConsumptionsService;
// Use With spécifique request by Month or Week
var fetchConsumptionsByMonthOrWeekService = function (sectionSubscriptionIds, mode, day, month, year, token) { return __awaiter(void 0, void 0, void 0, function () {
    var params, configuration, route, url, response;
    var _a, _b, _c, _d;
    return __generator(this, function (_e) {
        switch (_e.label) {
            case 0:
                if (!index_1.urlsConfig.values)
                    throw Error('No urls config found');
                params = '';
                configuration = { headers: { Authorization: "Bearer ".concat(token) } };
                if (mode === 'Month')
                    params = "/monthly";
                if (mode == 'Week')
                    params = "/weekly";
                if (mode == 'Year')
                    params = "/yearly";
                route = "/section_subscriptions/consumptions";
                url = "".concat(index_1.urlsConfig.values.DELIVERYPOINT_BASE_URL).concat(route).concat(params);
                return [4 /*yield*/, axiosInstance_1.default.post(url, {
                        sectionSubscriptionIds: sectionSubscriptionIds,
                        year: year,
                        month: month,
                        day: day
                    }, configuration)];
            case 1:
                response = _e.sent();
                (0, common_1.LogRequestResponse)(response);
                return [2 /*return*/, {
                        consumptions: (_a = response.data) === null || _a === void 0 ? void 0 : _a.consumptions.map(function (d) { return new Consumption_1.default(d); }),
                        isRemoteReading: (_b = response.data) === null || _b === void 0 ? void 0 : _b.isRemoteReading,
                        isEstimateConsumption: (_c = response.data) === null || _c === void 0 ? void 0 : _c.isEstimateConsumption,
                        isYearlyViewOnly: (_d = response.data) === null || _d === void 0 ? void 0 : _d.isYearlyViewOnly
                    }];
        }
    });
}); };
exports.fetchConsumptionsByMonthOrWeekService = fetchConsumptionsByMonthOrWeekService;
function fetchConsumptionsServiceOld(sectionSubscriptionId, token, config) {
    var _a, _b, _c;
    return __awaiter(this, void 0, void 0, function () {
        var route, response;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    if (!index_1.urlsConfig.values)
                        throw Error('No urls config found');
                    if (config) {
                        return [2 /*return*/, fetchConsumptionsByMonthOrWeekServiceOld(sectionSubscriptionId, config.mode, config.day, config.month, config.year, token)];
                    }
                    route = "/section_subscription/".concat(sectionSubscriptionId, "/consumptions");
                    return [4 /*yield*/, axiosInstance_1.default.get("".concat(index_1.urlsConfig.values.DELIVERYPOINT_BASE_URL).concat(route), {
                            headers: {
                                Authorization: "Bearer ".concat(token)
                            }
                        })];
                case 1:
                    response = _d.sent();
                    (0, common_1.LogRequestResponse)(response);
                    return [2 /*return*/, {
                            consumptions: (_a = response.data) === null || _a === void 0 ? void 0 : _a.consumptions.map(function (d) { return new Consumption_1.default(d); }),
                            isRemoteReading: (_b = response.data) === null || _b === void 0 ? void 0 : _b.isRemoteReading,
                            isYearlyViewOnly: (_c = response.data) === null || _c === void 0 ? void 0 : _c.isYearlyViewOnly
                        }];
            }
        });
    });
}
exports.fetchConsumptionsServiceOld = fetchConsumptionsServiceOld;
// Use With spécifique request by Month or Week
var fetchConsumptionsByMonthOrWeekServiceOld = function (sectionSubscriptionId, mode, day, month, year, token) { return __awaiter(void 0, void 0, void 0, function () {
    var route, params, url, response;
    var _a, _b, _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                if (!index_1.urlsConfig.values)
                    throw Error('No urls config found');
                route = "/section_subscription/".concat(sectionSubscriptionId, "/consumptions");
                params = '';
                if (mode === 'Month')
                    params = "/monthly?year=".concat(year, "&month=").concat(month);
                if (mode == 'Week')
                    params = "/weekly?year=".concat(year, "&month=").concat(month, "&day=").concat(day);
                if (mode == 'Year')
                    params = "/yearly?year=".concat(year);
                url = "".concat(index_1.urlsConfig.values.DELIVERYPOINT_BASE_URL).concat(route).concat(params);
                return [4 /*yield*/, axiosInstance_1.default.get(url, {
                        headers: {
                            Authorization: "Bearer ".concat(token)
                        }
                    })];
            case 1:
                response = _d.sent();
                (0, common_1.LogRequestResponse)(response);
                return [2 /*return*/, {
                        consumptions: (_a = response.data) === null || _a === void 0 ? void 0 : _a.consumptions.map(function (d) { return new Consumption_1.default(d); }),
                        isRemoteReading: (_b = response.data) === null || _b === void 0 ? void 0 : _b.isRemoteReading,
                        isYearlyViewOnly: (_c = response.data) === null || _c === void 0 ? void 0 : _c.isYearlyViewOnly
                    }];
        }
    });
}); };
exports.fetchConsumptionsByMonthOrWeekServiceOld = fetchConsumptionsByMonthOrWeekServiceOld;
// Download consumption
function downloadConsumptionDocumentService(familyId, token) {
    return __awaiter(this, void 0, void 0, function () {
        var route, response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!index_1.urlsConfig.values)
                        throw Error('No urls config found');
                    route = "/families/".concat(familyId, "/export");
                    return [4 /*yield*/, axiosInstance_1.default.get("".concat(index_1.urlsConfig.values.DELIVERYPOINT_BASE_URL).concat(route), {
                            headers: {
                                Authorization: "Bearer ".concat(token)
                            }
                        })];
                case 1:
                    response = _a.sent();
                    (0, common_1.LogRequestResponse)(response);
                    return [2 /*return*/, response];
            }
        });
    });
}
exports.downloadConsumptionDocumentService = downloadConsumptionDocumentService;
